module.exports = __webpack_public_path__ + "f50437770e857c29f9f0fac7841871dd.png";